import { LanguageAlphabet } from '@/types'

export const buildLocalizedArray = (latin?: string, cyrl?: string) => [
  { lang: LanguageAlphabet.UZ, value: latin ?? '' },
  { lang: LanguageAlphabet.RU, value: cyrl ?? '' },
]
